/*
 * Functions for Service Catalog (Bootstrap 5 version)
 * Template: templates/v5/servicecatalog/list.html
 */

(function (__module__, c2) {
  'use strict';

  const hideClassName = "d-none";
  const showClassName = "show";

  // Wait this long after the last keystroke before searching, so typing a
  // word costs one request instead of one per character.
  const searchDebounceMs = 300;
  // A single character matches nearly everything, so it isn't worth a query.
  const minSearchLength = 2;

  var searchTimer = null;
  var searchXHR = null;
  var lastSearched = null;

  function init() {
    // Filter checkboxes: rebuild URL when toggled
    $(".catalog-filter-checkbox").on("change", function () {
      setUrlQuery();
    });

    // Sort dropdown
    $("#catalogSortSelect").on("change", function () {
      setUrlQuery();
    });

    lastSearched = currentQuery();

    // Search form
    $("#catalog-search-form").on("submit", function (e) {
      e.preventDefault();
      searchNow();
    });

    // Search as the user types. Using "input" rather than "keyup" also covers
    // paste, the type=search clear button, and autofill.
    $("#catalog-search-input").on("input", function () {
      clearTimeout(searchTimer);

      var query = currentQuery();
      if (query.length > 0 && query.length < minSearchLength) {
        return;
      }
      if (query === lastSearched) {
        return;
      }

      searchTimer = setTimeout(search, searchDebounceMs);
    });

    // Enter searches immediately rather than waiting out the debounce
    $("#catalog-search-input").on("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        searchNow();
      }
    });

    // Remove individual filter badge
    $(".catalog-remove-filter").on("click", function (e) {
      e.preventDefault();
      var filterId = $(this).data("filter-id");
      $("#filter-" + $.escapeSelector(filterId)).prop("checked", false);
      setUrlQuery();
    });
  }

  function showContent() {
    $("#catalog-cards").addClass(showClassName).removeClass(hideClassName);
  }

  function currentQuery() {
    return ($("#catalog-search-input").val() || "").trim();
  }

  /*
   * Collect the current filter, sort and search state as query params.
   */
  function buildParams() {
    var params = new URLSearchParams();

    // Collect checked filters
    var filters = [];
    $(".catalog-filter-checkbox:checked").each(function () {
      filters.push($(this).val());
    });
    if (filters.length > 0) {
      params.set("filters", filters.join(","));
    }

    // Sort
    var sort = $("#catalogSortSelect").val();
    if (sort && sort !== "featured") {
      params.set("sort", sort);
    }

    // Search
    var query = currentQuery();
    if (query !== "") {
      params.set("q", query);
    }

    return params;
  }

  /*
   * Reload the page with the current filter, sort and search state. Used by
   * the filter and sort controls, which change the whole page.
   */
  function setUrlQuery() {
    $("#catalog-cards").addClass(hideClassName).removeClass(showClassName);
    c2.spinners.showSpinner({selector: "#spinner-target"});

    window.location = "?" + buildParams().toString();
  }

  function searchNow() {
    clearTimeout(searchTimer);
    search();
  }

  /*
   * Fetch matching blueprints and swap in the results, leaving the search box
   * focused and the caret where the user left it. The server does the
   * matching, so results are identical to a full page load.
   */
  function search() {
    var params = buildParams();
    var partialParams = new URLSearchParams(params.toString());
    partialParams.set("partial", "1");

    lastSearched = currentQuery();

    // Drop any request already in flight, otherwise a slow response for an
    // earlier prefix can land after a later one and paint stale results.
    if (searchXHR) {
      searchXHR.abort();
      searchXHR = null;
    }

    c2.spinners.showSpinner({selector: "#spinner-target"});

    var xhr = $.get("?" + partialParams.toString());
    searchXHR = xhr;

    xhr.done(function (html) {
      $("#catalog-results").html(html);
      showContent();
      // Keep the address bar shareable and refresh-safe without adding a
      // history entry per keystroke.
      var queryString = params.toString();
      window.history.replaceState(
        null, "", queryString ? "?" + queryString : window.location.pathname
      );
    });

    xhr.always(function () {
      if (searchXHR === xhr) {
        searchXHR = null;
        c2.spinners.hideSpinner({selector: "#spinner-target"});
      }
    });
  }

  c2[__module__] = {
    init: init,
    showContent: showContent,
    setUrlQuery: setUrlQuery,
    search: search
  };
})('catalog', window.c2);
